export default __webpack_public_path__ + "static/media/cowboy.1dcbd5de.png";